import { Button as BaseButton, ButtonProps } from '@material-ui/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

// @ts-ignore
interface IButtonProps extends ButtonProps {
  redirect?: boolean;
}

const Button = (props: IButtonProps): JSX.Element => {
  const { href, onClick, redirect, ...rest } = props;

  const navigate = useNavigate();

  const onButtonClick = href
    ? () => {
        if (props.redirect) {
          location.href = href;
        } else if (history) {
          navigate(href);
        }
      }
    : undefined;

  return (
    <BaseButton
      {...rest}
      onClick={event => {
        if (onClick !== undefined) {
          onClick(event);
        }

        if (onButtonClick !== undefined && !event.isDefaultPrevented()) {
          onButtonClick();
        }
      }}
    />
  );
};

export { Button };
